<template>
  <div>
    <Pos_debt_balance_pay/>
  </div>
</template>

<script>
import Pos_debt_balance_pay from "@/components/adminArin/pos_system/product/Pos_debt_balance_pay";
export default {
  name: "PosDebtBalancePay",
  components: {
    Pos_debt_balance_pay
  }
}
</script>

<style scoped>

</style>
